import Sorting from '@/shared/models/Sorting';
import WorkPreparationRole, { WorkPreparationRoleId } from './WorkPreparationRole';
import WorkPreparationSearchResult from './WorkPreparationSearchResult';

export default class WorkPreparationSearchResultContainer {
  roleId: WorkPreparationRoleId | null = null;
  roles: Array<WorkPreparationRole> = [];
  searchResults: Array<WorkPreparationSearchResult> = [];

  sortSearchResults(sorting: Sorting<WorkPreparationSearchResult>): void {
    this.searchResults = sorting.applyTo(this.searchResults);
  }
}